<template>
    <div class="mod-register">
        <mini-header :headerTitle="!$route.query.userInfo ? '注册' : '个人信息'"></mini-header>
        <div class="register-main" v-if="!isSuccess">
            <div class="mod-title">
                <h1>{{ !$route.query.userInfo ? '注册新用户' : '个人信息' }}</h1>
                <span class="under-line"></span>
            </div>
            <el-form :disabled="$route.query.userInfo == 1" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                <el-divider content-position="left">联系人信息</el-divider>
                <div class="form_panel">
                    <input type="password" hidden autocomplete="new-password" />
                    <el-form-item label="用户名" prop="name">
                        <el-input v-model="ruleForm.name" maxlength="11"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="phone">
                        <el-input v-model="ruleForm.phone" maxlength="11" readonly onfocus="this.removeAttribute('readonly');"></el-input>
                    </el-form-item>
                    <el-form-item v-if="!$route.query.userInfo" label="密码" prop="password">
                        <el-input type="password" v-model="ruleForm.password" maxlength="16"></el-input>
                    </el-form-item>
                    <el-form-item v-if="!$route.query.userInfo" label="确认密码" prop="comfirmPassword">
                        <el-input type="password" v-model="ruleForm.comfirmPassword" maxlength="16"></el-input>
                    </el-form-item>
                    <el-form-item label="QQ号" prop="qq">
                        <el-input v-model="ruleForm.qq" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="微信号" prop="wx">
                        <el-input v-model="ruleForm.wx" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="头像上传" prop="avatar">
                        <el-upload accept=".jpg,.png" :on-change="(res) => { imgChange(res, 'avatar') }" class="uploader" :action="''" :show-file-list="false" :auto-upload="false">
                            <el-image v-if="ruleForm.avatar" :src="getUrl(ruleForm.avatar)">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                            </el-image>
                            <i v-if="!$route.query.userInfo && !ruleForm.avatar" class="el-icon-plus"></i>
                            <div v-if="!$route.query.userInfo" class="el-upload__tip" slot="tip">仅支持JPG/PNG格式。</div>
                        </el-upload>
                    </el-form-item>
                </div>
                <el-divider content-position="left">委托单位信息</el-divider>
                <div class="form_panel">
                    <el-form-item label="委托单位名称" prop="dept.name">
                        <el-select placeholder="" maxlength="50" class="w100" filterable allow-create v-model="ruleForm.dept.name" @change="setForm" :loading="loading" :remote-method="getOptions" remote>
                            <el-option :label="op.name" :value="op.id" v-for="(op, i) of depts" :key="i"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单位地址" prop="dept.addr">
                        <el-input :disabled="!!ruleForm.dept.id" v-model="ruleForm.dept.addr" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="邮编" prop="dept.postcode">
                        <el-input :disabled="!!ruleForm.dept.id" v-model="ruleForm.dept.postcode" maxlength="6"></el-input>
                    </el-form-item>
                    <el-form-item label="传真" prop="dept.fax">
                        <el-input :disabled="!!ruleForm.dept.id" v-model="ruleForm.dept.fax" maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="营业执照" prop="dept.businessLicense" class="uploadItem">
                        <el-upload :disabled="!!ruleForm.dept.id" accept=".jpg,.png,.pdf" :on-change="(res) => { imgChange(res, 'dept.businessLicense') }" class="uploader" :action="''" :show-file-list="false" :auto-upload="false">
                            <el-image v-if="ruleForm.dept.businessLicense && ruleForm.dept.businessLicenseType != '.pdf'" :src="getUrl(ruleForm.dept.businessLicense)">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                            </el-image>
                            <div class="uploadText" v-if="ruleForm.dept.businessLicense && ruleForm.dept.businessLicenseType == '.pdf'">
                                <a class="ellipsis" @click.prevent="openPdf(ruleForm.dept.businessLicense_)">查看营业执照</a>
                                <i v-if="$route.query.userInfo == 1" class="el-icon-close" @click.stop="ruleForm.dept.businessLicense = ''"></i>
                            </div>
                            <i v-if="!$route.query.userInfo && !ruleForm.dept.businessLicense" class="el-icon-plus"></i>
                            <div v-if="!$route.query.userInfo" class="el-upload__tip" slot="tip">仅支持PDF/JPG/PNG格式。</div>
                        </el-upload>
                    </el-form-item>
                </div>
            </el-form>
            <div class="btn-control">
                <el-button v-if="!$route.query.userInfo" round @click="$router.push({ name: 'login' })">返回</el-button>
                <el-button v-if="!$route.query.userInfo" type="primary" round @click="submitForm">确认</el-button>
                <el-button style="width: 250px;" v-if="$route.query.userInfo == 1" type="primary" round @click="$router.push({ name: 'updateUserInfo' })">修改账户信息</el-button>
                <p style="color: #606266;margin-top:7px;" v-if="$route.query.userInfo == 1">注：请谨慎修改，谨防数据丢失。</p>
            </div>
        </div>
        <div class="result" v-if="isSuccess">
            <el-result icon="success" title="恭喜您！注册成功。">
                <template slot="subTitle">
                    <p>您好！您已经成功注册网上受理<br />请点击下方按钮登录使用</p>
                </template>
                <template slot="extra">
                    <button class="diy_button primary_button" @click="$router.push({ name: 'login' })">{{ backLogin }}s后返回登录页面</button>
                </template>
            </el-result>
        </div>
        <main-footer></main-footer>
        <!-- 用户协议 -->
        <agreement ref="agreement"></agreement>
    </div>
</template>

<script>
import { isMobile } from "@/utils/validate";
import { RSAEncrypt, previewUrl } from "@/utils";
import MiniHeader from "./../common/mini-header.vue";
import MainFooter from "./../main-footer.vue";
import Agreement from "./agreement.vue";
export default {
    components: {
        MiniHeader,
        MainFooter,
        Agreement,
    },
    data() {
        var validateMobile = (rule, value, callback) => {
            if (!isMobile(value)) {
                callback(new Error("手机号格式错误"));
            } else {
                callback();
            }
        };

        var validatePassword = (rule, value, callback) => {
            // const reg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,16}/;
            // 1.密码必须由字母、数字组成，区分大小写
            // 2.密码长度为8-16位
            const reg = /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{6,16}$/;
            if (value == "" || value == undefined || value == null) {
                callback();
            } else {
                if (!reg.test(value)) {
                    callback(new Error("必须由字母、数字组成，区分大小写，6到16位"));
                } else {
                    callback();
                }
            }
        };
        var validateComfirmPassword = (rule, value, callback) => {
            if (!/\S/.test(value)) {
                callback(new Error("确认密码不能为空"));
            } else if (this.ruleForm.password !== value) {
                callback(new Error("确认密码与密码输入不一致"));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                phone: "",
                qq: "",
                wx: "",
                name: "",
                password: "",
                comfirmPassword: "",
                avatar: '',
                avatarFileName:'',
                dept: {
                    name: '',
                    postcode: '',
                    addr: '',
                    fax: '',
                    businessLicense: '',
                    id:'',
                    businessLicenseFileName:''
                }
            },
            rules: {
                'dept.businessLicense': [{ required: true, message: "请上传营业执照", trigger: "change" }],
                phone: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    { validator: validateMobile, trigger: "blur" },
                ],
                name: [
                    { required: true, message: "请输入用户名", trigger: "blur" }
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                    { validator: validatePassword, trigger: "blur" },
                ],
                comfirmPassword: [
                    { required: true, message: "请输入确认密码", trigger: "blur" },
                    { validator: validateComfirmPassword, trigger: "blur" },
                ],
                'dept.name': [
                    { required: true, message: "请输入委托单位名称", trigger: "change" }
                ],
                'dept.addr': [
                    { required: true, message: "请输入单位地址", trigger: "change" }
                ]
            },
            showCaptcha: true,
            count: "",
            backLogin: 3,
            timer: null,
            timer2: null,
            isSuccess: false,
            depts:[],
            loading: false
        };
    },
    mounted() {
        const type = this.$route.query.userInfo;
        if (type && type == 1) {
            // 获取用户信息
            this.$http.get(this.$api.shiroApi.userInfo).then(({ data }) => {
                this.ruleForm = data.data;
                if(!this.ruleForm.dept){
                    this.ruleForm.dept = {
                        name: '',
                        postcode: '',
                        addr: '',
                        fax: '',
                        businessLicense: '',
                        id:'',
                        businessLicenseFileName:''
                    }
                }
            });
        } else {
            this.$refs.agreement.visible = true;
        }
    },
    methods: {
        getOptions(query){
            if (query !== '') {
            this.loading = true;
            setTimeout(() => {
                this.$http.get(`${this.$api.shiroApi.searchDeptList}?searchKey=${query}`).then(({ data }) => {
                    this.depts = data.data;
                    this.loading = false;
                });
            }, 200);
            } else {
                this.depts = [];
            }
        },
        setForm(val){
            const checkOne = this.depts.find(v=>v.id==val);
            Object.keys(this.ruleForm.dept).forEach(v =>{
                this.ruleForm.dept[v] = checkOne ? checkOne[v] : '';
            })
            if(!checkOne){
                this.ruleForm.dept.name = val;
                this.ruleForm.dept.id = '';
            }
            this.$refs["ruleForm"].validateField(['dept.name','dept.addr','dept.businessLicense'])
        },
        openPdf(url) {
            window.open(url)
        },
        imgChange(r, f) {
            this.getBase64(r.raw).then(res => {
                if (f == 'avatar') {
                    this.ruleForm.avatar = res;
                    this.ruleForm.avatarFileName = r.name;
                } else {
                    this.ruleForm.dept.businessLicense = res;
                    this.ruleForm.dept.businessLicenseFileName = r.name;
                    this.ruleForm.dept.businessLicense_ = URL.createObjectURL(r.raw);
                    this.ruleForm.dept.businessLicenseType = r.name.substr(r.name.lastIndexOf('.')).toLowerCase();
                    this.$refs["ruleForm"].validateField('dept.businessLicense');
                }
            });
        },
        getBase64(url) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.readAsDataURL(url);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            })
        },
        getUrl(url) {
            if(url.indexOf('data:image')>-1){
                return url
            }
            return previewUrl(url);
        },
        // 表单提交
        submitForm() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    let params = JSON.parse(JSON.stringify(this.ruleForm));
                    params.password = RSAEncrypt(params.password);
                    delete params.comfirmPassword;
                    delete params.dept.businessLicenseType;
                    delete params.dept.businessLicense_;
                    this.$http.post(this.$api.shiroApi.register, params).then(({ data }) => {
                        if (data.code === 200) {
                            this.$message({
                                message: "注册成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.isSuccess = true;
                                    this.$router.replace({ name: "login" });
                                },
                            });
                        }
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.uploader {
    width: 320px;
    height: 156px;
    border-radius: 4px;
    border: 1px solid #DEDEDE;

    ::v-deep .el-upload {
        width: 100%;
        height: 100%;
        line-height: 156px;
        text-align: center;
    }

    .el-image {
        height: 154px;
    }

    i {
        font-size: 26px;
        width: 100%;
        color: #999;
    }

    .el-upload__tip {
        line-height: 14px;
        position: absolute;
        bottom: -18px;
        margin: 0;
    }
}
::v-deep .uploadItem.is-error{
    .el-form-item__error {
        padding-top: 18px !important;
    }
}
</style>
